function text(node) {
  return node.value || (node.children || []).map(text).join('')
}

export function remarkHeadingIds() {
  return tree => {
    const seen = new Map()
    function visit(node) {
      if (node.type === 'heading') {
        const base =
          text(node)
            .toLowerCase()
            .replace(/[^\p{L}\p{N}]+/gu, '-')
            .replace(/^-|-$/g, '') || 'section'
        const count = (seen.get(base) || 0) + 1
        seen.set(base, count)
        node.data = {
          ...node.data,
          hProperties: {
            ...node.data?.hProperties,
            id: count === 1 ? base : `${base}-${count}`,
          },
        }
      }
      node.children?.forEach(visit)
    }
    visit(tree)
  }
}

export function remarkOutline() {
  return tree => {
    const headings = []
    function visit(node) {
      if (node.type === 'heading' && [2, 3].includes(node.depth)) {
        headings.push({
          type: 'listItem',
          spread: false,
          children: [
            {
              type: 'paragraph',
              children: [
                {
                  type: 'link',
                  url: `#${node.data.hProperties.id}`,
                  children: node.children,
                },
              ],
            },
          ],
        })
      } else node.children?.forEach(visit)
    }
    visit(tree)
    tree.children = [
      {
        type: 'list',
        ordered: false,
        spread: false,
        children: headings,
      },
    ]
  }
}
